export const sources={avif:"__VITE_ASSET__DLvwvAA6__ 85w"};export const img={src:"__VITE_ASSET__t6YeN9S0__",w:85,h:33};export default{sources:sources,img:img};